import React from 'react'

export const UserManagementCardIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.592 13.207C11.281 13.207 14.434 13.766 14.434 15.999C14.434 18.232 11.302 18.807 7.592 18.807C3.902 18.807 0.75 18.253 0.75 16.019C0.75 13.785 3.881 13.207 7.592 13.207Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.59108 10.02C5.16908 10.02 3.20508 8.057 3.20508 5.635C3.20508 3.213 5.16908 1.25 7.59108 1.25C10.0121 1.25 11.9761 3.213 11.9761 5.635C11.9851 8.048 10.0351 10.011 7.62208 10.02H7.59108Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4844 8.88177C16.0854 8.65677 17.3184 7.28277 17.3214 5.61977C17.3214 3.98077 16.1264 2.62077 14.5594 2.36377"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5957 12.7324C18.1467 12.9634 19.2297 13.5074 19.2297 14.6274C19.2297 15.3984 18.7197 15.8984 17.8957 16.2114"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
